var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isBrandable
    ? _c("BrandableAddonModal", {
        attrs: {
          selectedAddon: _vm.selectedAddon,
          addonProducts: _vm.addonProducts,
          cartProducts: _vm.cartProducts,
          recommendedProducts: _vm.recommendedProducts
        },
        on: {
          closemodal: function($event) {
            return _vm.closeModal()
          },
          changeselectedaddon: function($event) {
            return _vm.openModal($event)
          }
        }
      })
    : _c("NormalAddonModal", {
        attrs: {
          selectedAddon: _vm.selectedAddon,
          addonProducts: _vm.addonProducts,
          cartProducts: _vm.cartProducts,
          recommendedProducts: _vm.recommendedProducts
        },
        on: {
          closemodal: function($event) {
            return _vm.closeModal()
          },
          changeselectedaddon: function($event) {
            return _vm.openModal($event)
          }
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }